import { Bell, Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "~/components/ui/card";
import { Button } from "~/components/ui/button";
import { usePushSetting } from "~/lib/use-push-setting";

export function NotificationsCard() {
  const { status, busy, error, turnOn } = usePushSetting();

  if (status === "unsupported") return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Notifications</CardTitle>
        <CardDescription>Get alerts about parcels and replies, even when this tab isn't open.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {error && <p className="text-destructive text-[13px]">{error}</p>}
        {status === "granted" && !error ? (
          <div className="text-text-faint flex items-center gap-2 text-[13px]">
            <Check className="text-foreground" /> Notifications are on for this device.
          </div>
        ) : status === "denied" ? (
          <p className="text-text-faint text-[13px]">Notifications are blocked. Allow them for this site in your browser settings, then reload.</p>
        ) : (
          <Button variant="secondary" loading={busy} onClick={() => void turnOn()}>
            <Bell /> Turn on notifications
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
